fragment ProductVariationMediaFragment on ProductVariationMedia {

    ...MediaFragment

    pivot {
        priority
    }
}